import React from "react";
import Header from "../../components/Header"; 
import Footer from "../../components/Footer";
import UserLeftSidebar from "../Components/UserLeftSidebar";
import PurchaseRight from "../Layouts/PurchaseRight";



export default function PurchaseHistory() {
  return (
    <div>
      <Header mode="dark" />

      <div className="container-fluid">
        <div className="dashboard-full-page">
      
      <UserLeftSidebar />

      <PurchaseRight />

       </div>
      </div>

 
      <Footer />
    </div>
  );
}

